export class commonAll {

  public static STORE_MODULE_NAME:string = 'commonAll'

}
